import { type FC, type PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react';
import { NotificationsCountContext } from '@Contexts/notificationsCount';
import { useStagedOrdersCountQuery } from '@Hooks/Staging';
import { MessagingConstants } from '@Model';
import { useHubMethod } from '@Contexts/signal';

export const NotificationsCountProvider: FC<PropsWithChildren> = ({ children }) => {
    const { count, isLoading } = useStagedOrdersCountQuery();
    const [stagedOrders, setStagedOrders] = useState(0);

    useEffect(() => {
        if (!isLoading) {
            setStagedOrders(count);
        }
    }, [count, isLoading]);

    const handleStagingUpdate = useCallback((eventJsonString: string) => {
        const parsed = JSON.parse(eventJsonString);

        if ('orders' in parsed) {
            const ordersCount = parsed.orders;
            if (typeof ordersCount !== 'number') {
                return;
            }
            setStagedOrders(parsed['orders']);
        }
    }, []);

    useHubMethod(MessagingConstants.staging_update_counts, handleStagingUpdate);

    const value = useMemo(
        () => ({
            stagedOrders,
        }),
        [stagedOrders],
    );

    return <NotificationsCountContext.Provider value={value}>{children}</NotificationsCountContext.Provider>;
};
